import { createDraftSafeSelector } from '@reduxjs/toolkit'
import { RootState } from '../core'

export const packageState = createDraftSafeSelector(
  (state: RootState) => state,
  (state) => state.package,
)

export const selectPackages = createDraftSafeSelector(packageState, (state) => state.packages)

export const selectCheckoutInfo = createDraftSafeSelector(
  packageState,
  (state) => state.checkoutInfo,
)
